import React from 'react';

interface INotAvailableButton {
  item: any
}
const NotAvailableButton: React.FC<INotAvailableButton> = ({ item }) => {
  return (
    <button disabled={true} className="btn btn-large w-100 mx-auto mw-auto">
      {item?.is_delivery ? 'Unavailable' : 'Unavailable for delivery'}
    </button>
  );
};

export default NotAvailableButton;
